import { FC } from 'react';
import styled from 'styled-components';
import { darken } from 'polished';
import { useNavigate } from 'react-router-dom';
import { EditButton, FontAwesome } from 'Elements';
import styles from 'partials/homepage/card/staff-card.module.scss';

interface Props {
	name: string;
	position: string;
	image: string;
	id: string;
	preview?: boolean;
	staffType: 'members' | 'employees';
	email?: string;
	phoneNumber?: string;
}

const Image = styled.img<{
	profileType: 'communityPartner' | 'businessPartner';
}>`
	${({ theme, profileType }) =>
		theme[profileType].primaryColor &&
		`border-color: ${theme[profileType].primaryColor};`}
`;

const Position = styled.span<{
	profileType: 'communityPartner' | 'businessPartner';
}>`
	${({ theme, profileType }) =>
		theme[profileType].primaryColor &&
		`background-color: ${darken(0.05, theme[profileType].primaryColor)}`}
`;

export const PreviewProfileStaffCard: FC<Props> = ({
	name,
	position,
	image,
	id,
	preview = true,
	staffType,
	email,
	phoneNumber
}) => {
	const navigate = useNavigate();
	const defaultImage = '/assets/img/default-image.png';
	const profileType =
		staffType === 'members' ? 'communityPartner' : 'businessPartner';

	const handleNavigate = () => {
		navigate(`/${staffType}/${id}`, {
			state: {
				prevPath: '/home'
			}
		});
	};

	return (
		<article className={styles.card} onClick={handleNavigate}>
			<div className={styles.imageWrapper}>
				<Image
					src={image || defaultImage}
					alt={name}
					className={styles.image}
					profileType={profileType}
				/>
				<Position profileType={profileType} className={styles.position}>
					{position}
				</Position>
			</div>
			<h3 className="text-gray-5 fs-6 fw-bold mt-2">{name}</h3>
			{email &&
				<div className='my-2'>
					<FontAwesome icon="envelope" size="1x" className='me-2' />
					<span className='text-gray-3'>{email}</span>
				</div>}
			{phoneNumber &&
				<div>
					<FontAwesome icon="phone" size="1x" className='me-2' />
					<span className='text-gray-3'>{phoneNumber}</span>
				</div>}
			{!preview && (
				<div className="edit-overlay">
					<EditButton className="edit-overlay-icon" />
				</div>
			)}
		</article>
	);
};
